import { SuggestedComplianceNoteService } from "@common/client"
import { complianceNoteLatestKey } from "./compliance-notes"
import { makeAxiosMutation, makeQuery } from "./utils"

export const suggestedComplianceNoteBaseKey = ["suggested-compliance_note"]

export const generateNoteContentByDescriptionQuery = makeQuery({
  serviceCall: SuggestedComplianceNoteService.generateNoteContentByDescription,
  queryKey: (params) => [...suggestedComplianceNoteBaseKey, params.description],
})

export const getSuggestedComplianceNoteQuery = makeQuery({
  serviceCall: SuggestedComplianceNoteService.readItem,
  queryKey: (id) => [...suggestedComplianceNoteBaseKey, id],
})

export const useUpdateSuggestedComplianceNoteMutation = makeAxiosMutation({
  serviceCall: SuggestedComplianceNoteService.updateItem,
  invalidates: (_, res) => [[...suggestedComplianceNoteBaseKey, res.id]],
})

export const useAcceptSuggestedComplianceNoteByIdMutation = makeAxiosMutation({
  serviceCall:
    SuggestedComplianceNoteService.acceptSuggestedComplianceNoteRoute,
  invalidates: ({ id }) => [
    [...suggestedComplianceNoteBaseKey, id],
    complianceNoteLatestKey(),
  ],
})
